<script lang='ts'>
  import * as _ from 'lodash';
  import type { SellSheet } from '@shared/types/SellSheet';
  import type { SellSheetDistributorUser } from '@shared/types/User';

  export let sellSheet: SellSheet;
  export let errorState;
  export let saveEdits: () => void;
  export let user: SellSheetDistributorUser;

  const save = _.debounce(saveEdits, 250);

  $: errorState;
</script>

<div class="padding--small background-white fizz-styles">
  {#if user.distributors.length > 1}
    <span class="fizz-label fizz-stack-4">Distributor</span>
    <p class="fizz-flex-row-4 fizz-text-medium fizz-stack-12">{sellSheet.distributor.name}</p>
  {/if}
  <form class="fizz-flow-16">
    <label class="fizz-label fizz-stack-4" for="input-text">Name</label>
    <input
    type="text"
    id="sell-sheet-name"
    name="input-text"
    class="fizz-input-text {errorState && errorState.keys.hasOwnProperty('name') ? 'fizz-input-error' : ''}"
    bind:value={sellSheet.name}
    on:keyup|preventDefault={save}
    >
    {#if errorState && errorState.keys}
      <p class="fizz-flex-row-4 fizz-text-urgent fizz-text-medium">
        <span>Name {errorState.keys.name}</span>
      </p>
    {/if}

    <label class="fizz-label fizz-stack-4" for="textarea">Sheet Notes</label>
    <textarea
      class="fizz-textarea"
      name="textarea"
      id="sell-sheet-notes"
      bind:value={sellSheet.notes}
      on:keyup|preventDefault={save}
      ></textarea>
  </form>
</div>
